// extracted by mini-css-extract-plugin
export default {"novalue":"NoValue_novalue__RX69m"};